import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "../data/menuData";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden border-t-2 border-black bg-white p-3 flex gap-2"
    >
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid="sticky-call-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 brutal-border bg-[#D92525] text-white font-bold px-3 py-3 text-sm uppercase tracking-wide"
      >
        <Phone size={18} strokeWidth={2.5} />
        Call
      </a>
      <a
        href={WA_LINK}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-whatsapp-btn"
        className="flex-[2] inline-flex items-center justify-center gap-2 brutal-border bg-[#25D366] text-black font-bold px-3 py-3 text-sm uppercase tracking-wide"
      >
        <MessageCircle size={18} strokeWidth={2.5} />
        Order on WhatsApp
      </a>
    </div>
  );
}
